<div class="grid-container padding-y-4">
    <div class="grid-row">
        <fieldset class="usa-fieldset">
            <legend class="usa-legend usa-legend--large">Define FRT SRO</legend>
        </fieldset>
    </div>
    <form id="ratesSroMaintenanceSearchGroup" role="form" [formGroup]="ratesSroMaintenanceSearchGroup">
        <fieldset class="usa-fieldset">
            <div class="grid-row grid-gap-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label" for="sro">SRO (Please hit Enter to search or add an SRO)<small
            class="usa-hint usa-hint--required">*</small></label>
                    <input type="text" placeholder="Enter SRO ID to Search" id="sro" class="usa-input maxw-full" formControlName='sroSearch' [typeahead]="sroIDList" [typeaheadMinLength]="1" [typeaheadOptionsLimit]="10" [maxlength]="10" oninput="this.value = this.value.toUpperCase()"
                        (keyup.enter)="onSroSearch($event.target.value)">
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="tl_minimum_pct" class="usa-label">{{serviceLevel}} Minimum Value</label>
                    <input type="number" id="minimum_pct" (focusout)="validateMin($event)" placeholder="Enter Number Only" class="usa-input maxw-full" formControlName="minimumPct" appNumbersOnly>
                    <span class="text-error" *ngIf="this.alertMaxMin === 1">
            <br>Please review Min Value and Max Value. If you dont have records for those values, leave it blank.
          </span>
                    <span class="text-error" *ngIf="this.alertMaxMin === 3">
            <br>Please check Min Value.
          </span>
                    <span class="text-error" *ngIf="this.ratesSroMaintenanceSearchGroup.get('minimumPct').hasError('max')">
            <br>Min Value must between
            <span *ngIf="serviceLevel == 'TL'">( 0 - 9999999.99 )</span>
                    <span *ngIf="serviceLevel == 'LTL'">( 0 - 999.99 )</span>
                    </span>
                    <span class="text-error" *ngIf="this.ratesSroMaintenanceSearchGroup.get('minimumPct').hasError('pattern')">
            <br>Only 2 numbers after decimal place.
          </span>
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label" for="tl_maximum_pct">{{serviceLevel}} Maximum Value</label>
                    <input type="number" id="maximum_pct" (focusout)="validateMax($event)" placeholder="Enter Number Only" class="usa-input maxw-full" formControlName="maximumPct" appNumbersOnly>
                    <span class="text-error" *ngIf="this.alertMaxMin === 1">
            <br>Please review Min Value and Max Value. If you dont have records for those values, leave it blank.
          </span>
                    <span class="text-error" *ngIf="this.alertMaxMin === 2">
            <br>Please check Max Value.
          </span>
                    <span class="text-error" *ngIf="this.ratesSroMaintenanceSearchGroup.get('maximumPct').hasError('max')">
            <br>Max Value must between
            <span *ngIf="serviceLevel == 'TL'">( 0 - 9999999.99 )</span>
                    <span *ngIf="serviceLevel == 'LTL'">( 0 - 999.99 )</span>
                    </span>
                    <span class="text-error" *ngIf="this.ratesSroMaintenanceSearchGroup.get('maximumPct').hasError('pattern')">
            <br>Only 2 numbers after decimal place.
          </span>
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="this.ratesSroMaintenanceSearchGroup.get('sroSearch').invalid &&
                      (this.ratesSroMaintenanceSearchGroup.get('sroSearch').touched
                      || this.ratesSroMaintenanceSearchGroup.get('sroSearch').dirty)">
                    <small class="text-error">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Please Enter Valid SRO
          </small>
                </div>
            </div>
            <div class="grid-row grid-gap-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="sro_agency" class="usa-label">Agency Name</label>
                    <ng-template #agencySearchTemplate let-model="item" let-index="index">
                        {{model.agencyBureauName}} - {{model.agencyCode}}
                    </ng-template>
                    <input id="sro_agency" class="usa-input maxw-full" formControlName='agencyName' placeholder="Select agency" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="300" [typeaheadMinLength]="0" (typeaheadOnSelect)="onAgencyNameChange($event)"
                        typeaheadOptionField="agencyBureauName" [typeahead]="agencyCustomerList" [typeaheadItemTemplate]="agencySearchTemplate" [typeaheadScrollable]="true">
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="sro_bureau" class="usa-label">Bureau Name</label>
                    <select id="sro_bureau" class="usa-select maxw-full" formControlName="bureauName" (change)="onBureauChange($event.target.value)">
            <option hidden value='null'>Choose</option>
            <option *ngFor="let bureau of agencyBureauList" [value]="bureau.bureauCode">
              {{bureau.agencyBureauName}} -
              {{bureau.bureauCode}}
            </option>
          </select>
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label" for="sro_location">Location</label>
                    <select id="sro_location" class="usa-select maxw-full" formControlName="agencyBureauLocation" (change)="sroListByAgencyIdAndLocation($event.target.value)">
            <option hidden value='null'>Choose</option>
            <option *ngFor="let agencyBureauDet of agencyBureauData" [value]="agencyBureauDet.agencyId">
              {{agencyBureauDet.agencyLocation}}
            </option>
          </select>
                </div>
            </div>
            <hr>
            <div class="grid-row">
                <h3 class="usa-legend usa-legend--medium">Information</h3>
            </div>
            <div class="grid-row grid-gap-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label" for="sro_route_order">Standing Route Order</label>
                    <select id="sro_route_order" class="usa-select maxw-full" formControlName="sroCode" (change)="onSroChange($event.target.value)">
            <option hidden value='null'>Choose</option>
            <option *ngFor="let sro of sroList" [value]="sro.sroId">
              {{sro.sroId}}
            </option>
          </select>
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label" for="sro_effective_date">SRO Effective Date<small class="required">*</small></label>
                    <input type="text" id="sro_effective_date" class="usa-input maxw-full" formControlName="effectiveDate" placeholder="mm/dd/yyyy" bsDatepicker [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label" for="sro_expiration_date">SRO Expiration Date</label>
                    <input type="text" id="sro_expiration_date" class="usa-input maxw-full" formControlName="expiryDate" placeholder="mm/dd/yyyy" bsDatepicker [minDate]="minExpiryDate" [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
                </div>
            </div>

            <div class="grid-gap-2 grid-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label" for="sro_rate_type">SRO Type <small class="required">*</small></label>
                    <select id="sro_rate_type" class="usa-select maxw-full" formControlName="sroType">
            <option hidden value='null'>Choose</option>
            <option *ngFor="let srotype of sroTypes">{{srotype}}</option>
          </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                    <div class="grid-gap-2 grid-row">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                            <label class="usa-label" for="rate_type">Available Rate Type<small class="required">*</small></label>
                            <select multiple id="rate_type" class="usa-select define-height-usa-select maxw-full" formControlName="rateType">
                <option hidden value='null'>Choose</option>
                <option *ngFor="let rate of rateTypes" [value]="rate.rateTypeId">{{rate.legacyRateType}} -
                  {{rate.description}}</option>
              </select>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2 text-ceter define-margin-x-y-auto">
                            <button type="button" class="usa-button width-full" (click)="moveItems()">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
                            </svg>
              </button>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                            <label class="usa-label" for="assigned_rate_type">Assigned Rate Types</label>
                            <select multiple id="assigned_rate_type" class="usa-select define-height-usa-select maxw-full" formControlName="assignedrateType">
                                <option *ngFor="let assignedRateType of assignedRateTypes; let i = index"
                                        [value]="assignedRateType.legacyRateType" (dblclick)="handleRateTypesMultiDropdown(i)">
                                {{assignedRateType.legacyRateType}} - {{assignedRateType.description}}
                                </option>
                            </select>
                            <div style="font-weight: 700;">Double click on item to remove from this list.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label class="usa-label" for="sro_notes">Notes (the notes entered below will be shown up on freight
            queries)</label>
                    <textarea id="sro_notes" class="usa-textarea maxw-full" formControlName="sroNotes"></textarea>
                </div>
            </div>

            <hr>
            <div class="grid-row margin-top-3">
                <div class="grid-col-6 mobile-lg:grid-col-6 tablet:grid-col-6 desktop:grid-col-6">
                    <h3 class="usa-legend usa-legend--medium">Lanes</h3>
                </div>
                <div class="grid-col-6 mobile-lg:grid-col-6 tablet:grid-col-6 desktop:grid-col-6 text-right text-right">
                    <button type="button" class="usa-button" (click)="[addModal.show(), addOrigDestLanes()]">Add
          </button>
                </div>
            </div>
        </fieldset>
        <ag-grid-angular class="ag-theme-alpine" [gridOptions]="gridOptions" [animateRows]="true" [rowData]="origDestDetails"
                         [components]="frameworkComponents" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
        <hr>
        <div class="grid-row margin-y-1">
            <button type="button" class="usa-button width-auto margin-right-05 margin-left-2px" [disabled]="!this.ratesSroMaintenanceSearchGroup.valid" (click)="sroFormSave()">Save
      </button>
            <button type="button" class="usa-button usa-button--secondary width-auto margin-right-05 margin-left-2px" (click)="clearFormAll()">Reset
      </button>
        </div>
    </form>
</div>


<!-- Add Origin/Destination Modal -->
<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="add-origin-destination">
    <div class="usa-modal usa-modal--lg display-flex" id="example-modal-2" aria-labelledby="modal-2-heading" aria-describedby="modal-2-description">
        <div class="usa-modal__content">
            <div class="usa-modal__main padding-y-0 define-width">
                <h2 class="usa-modal__heading" id="modal-2-heading">
                    Add Origin/Destination
                </h2>
                <div class="usa-prose">
                    <form id="ratesSroMaintenanceAddGroup" role="form" [formGroup]="ratesSroMaintenanceAddGroup">
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label for="sro_zone" class="usa-label">Origin Country</label>
                                <select multiple id="sro_zone" class="maxw-full usa-select define-height-usa-select " formControlName="addOriginCountry">
                                    <option value="AllCountries">Check All Countries</option>
                                    <option *ngFor="let country of allCountriesList" [value]="country.stateCountryId">
                                    {{country.stateCountryName}}
                                    </option>
                                </select>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label class="usa-label" for="sro_dest_zone">Destination Country</label>
                                <select multiple id="sro_dest_zone" class="maxw-full usa-select define-height-usa-select" formControlName="addDestinationCountry">
                                    <option value="AllCountries">Check All Countries</option>
                                    <option *ngFor="let country of allCountriesList" [value]="country.stateCountryId">
                                        {{country.stateCountryName}}
                                    </option>
                                </select>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label class="usa-label" for="sro_zone">Origin Zone</label>
                                <select multiple id="sro_zone" class="maxw-full usa-select define-height-usa-select"
                                    formControlName="addOriginZone">
                                    <option *ngFor="let zone of allZonesList" [value]="zone.stateCountryId">
                                        {{zone.stateCountryName}}
                                    </option>
                                </select>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label class="usa-label" for="sro_dest_zone">Destination Zone</label>
                                <select multiple id="sro_dest_zone" class="maxw-full usa-select define-height-usa-select"
                                    formControlName="addDestinationZone">
                                    <option *ngFor="let zone of allZonesList" [value]="zone.stateCountryId">
                                        {{zone.stateCountryName}}
                                    </option>
                                </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label class="usa-label" for="sro_zone">Origin State</label>
                                <select multiple id="sro_zone" class="maxw-full usa-select define-height-usa-select"
                                    formControlName="addOriginState">
                                    <option value="AllStates">Check All CONUS States</option>
                                    <option *ngFor="let state of allStatesList" [value]="state.stateCountryId">
                                        {{state.stateCountryName}}
                                    </option>
                                </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label class="usa-label" for="sro_dest_zone">Destination State</label>
                                <select multiple id="sro_dest_zone" class="maxw-full usa-select define-height-usa-select"
                                    formControlName="addDestinationState">
                                    <option value="AllStates">Check All CONUS States</option>
                                    <option *ngFor="let state of allStatesList" [value]="state.stateCountryId">
                                        {{state.stateCountryName}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6" *ngIf="showAddress">
                                <ng-template #customItemTemplate let-model="item">{{model.cityName}}, {{model.stateAbbrev}}, {{model.zipCode}}
                                </ng-template>
                                <label for="origin" class="usa-label">Origin Address</label>
                                <input id="origin" class="usa-input maxw-full" formControlName="asyncOriginSearchString" [typeaheadAsync]="true"
                                    [typeahead]="dataSourceOrigin" (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
                                    (typeaheadOnSelect)="typeaheadOriginOnSelect($event)" typeaheadOptionField="cityName"
                                    [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
                                    [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100"
                                    placeholder="Enter a location or zip code">
                                <div class="my-2 is-loading text-primary" role="status" *ngIf="typeaheadLoading">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <div class="define-text-secondary"
                                    *ngIf="this.ratesSroMaintenanceAddGroup.get('originId').touched && this.ratesSroMaintenanceAddGroup.get('originId').hasError('required')">
                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                        <use xlink:href="/assets/img/sprite.svg#warning"></use>
                                    </svg> Destination is required
                                </div>
                                <label class="usa-label define-bottom-tag" *ngIf="ratesSroMaintenanceAddGroup.value.originId">
                                    {{ratesSroMaintenanceAddGroup.value.originId?.cityName}},
                                    {{ratesSroMaintenanceAddGroup.value.originId?.stateAbbrev}}
                                    {{ratesSroMaintenanceAddGroup.value.originId?.zipCode}}
                                </label>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6" *ngIf="showAddress">
                                <ng-template #customItemTemplate let-model="item">{{model.cityName}}, {{model.stateAbbrev}}, {{model.zipCode}}
                                </ng-template>
                                <label class="usa-label" for="destination">Destination</label>
                                <input id="destination" class="maxw-full usa-input" formControlName="asyncDestinationSearchString" [typeaheadAsync]="true"
                                    [typeahead]="dataSourceDestination" (typeaheadLoading)="changeTypeaheadDestinationLoading($event)"
                                    (typeaheadOnSelect)="typeaheadDestinationOnSelect($event)" typeaheadOptionField="cityName"
                                    [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
                                    [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" placeholder="Enter a location or zip code">
                                <div class="is-loading" role="status" *ngIf="typeaheadLoading">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <div class="text-danger"
                                    *ngIf="this.ratesSroMaintenanceAddGroup.get('destinationId').touched && this.ratesSroMaintenanceAddGroup.get('destinationId').hasError('required')">
                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                        <use xlink:href="/assets/img/sprite.svg#warning"></use>
                                    </svg> Destination is required
                                </div>
                                <label class="usa-label define-bottom-tag" *ngIf="ratesSroMaintenanceAddGroup.value.destinationId">
                                    {{ratesSroMaintenanceAddGroup.value.destinationId?.cityName}},
                                    {{ratesSroMaintenanceAddGroup.value.destinationId?.stateAbbrev}}
                                    {{ratesSroMaintenanceAddGroup.value.destinationId?.zipCode}}
                                </label>
                            </div>
                        </div>

                        <div class="grid-row grid-gap padding-top-4">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" >
                                <button type="button" class="usa-button" [disabled]="(
                                    (this.ratesSroMaintenanceAddGroup.get('addOriginCountry').value===null &&
                                    this.ratesSroMaintenanceAddGroup.get('addOriginZone').value===null &&
                                    this.ratesSroMaintenanceAddGroup.get('addOriginState').value===null &&
                                    this.ratesSroMaintenanceAddGroup.get('asyncOriginSearchString').value===null ) ||
                                    (this.ratesSroMaintenanceAddGroup.get('addDestinationCountry').value===null &&
                                    this.ratesSroMaintenanceAddGroup.get('addDestinationZone').value===null &&
                                    this.ratesSroMaintenanceAddGroup.get('addDestinationState').value===null &&
                                    this.ratesSroMaintenanceAddGroup.get('asyncDestinationSearchString').value===null))" (click)="[addOriginDestination(), addModal.hide()]">Add
                                </button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
            <button class="usa-button usa-modal__close" aria-label="Close this window" (click)="addModal.hide()" data-close-modal>
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
                </svg>
            </button>
        </div>
    </div>

</div>
